export default __webpack_public_path__ + "static/graphic-icon-play-store-1cd1261ad1e597c1f9a80cb8ab54d1f9.webp";